import OverviewSection from '@/components/Analytics/OverviewSection';
import { useAnalytics } from '@/contexts/AnalyticsContext';
import { Clock } from 'lucide-react';
import React from 'react';
import PerpsSection from './components/PerpsSection';
import RwaSection from './components/RwaSection';
import SpotSection from './components/SpotSection';

/**
 * Analytics page component
 * Displays overview metrics and various chart sections
 * Uses Figma Token color variables and real data
 */
const Analytics: React.FC = () => {
  const { data } = useAnalytics();

  const formatLastUpdated = (isoString?: string): string => {
    if (!isoString) return '--';
    const date = new Date(isoString);
    if (Number.isNaN(date.getTime())) return '--';
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${month}/${day}/${year}, ${hours}:${minutes}`;
  };

  const lastUpdated = formatLastUpdated(data?.overview?.createdAt);

  return (
    <div className="min-h-screen bg-solid-bg">
      {/* Main Content */}
      <div className="max-w-[1280px] mx-auto py-12">
        {/* Overview Metrics Section */}
        <section className="mb-12">
          {/* Section Header */}
          <div className="flex items-center justify-between h-6 mb-6">
            <h2 className="text-xl font-semibold text-text-black">Overview Metrics</h2>
            <div className="flex items-center gap-2 text-text-main-body">
              <Clock className="w-4 h-4" />
              <span className="text-sm">Last updated: {lastUpdated}</span>
            </div>
          </div>

          {/* Overview Cards */}
          <OverviewSection />
        </section>

        {/* RWA Charts Section */}
        <div className="mb-12">
          <RwaSection />
        </div>

        {/* Spot Charts Section */}
        <div className="mb-12">
          <SpotSection />
        </div>

        {/* Perps Charts Section */}
        <PerpsSection />
      </div>
    </div>
  );
};

export default Analytics;
